import React from "react";

import { Grid, Box, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { Button, Slider } from "../../../../components/base";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(4)}px ${theme.spacing(2.5)}px ${theme.spacing(4)}px ${theme.spacing(
      3.5
    )}px`,
  },
  sliderRow: {
    marginTop: theme.spacing(2.25),
    "&:last-child": {
      paddingBottom: theme.spacing(1.25),
    },
  },
  rootStyle: {
    minWidth: 150,
    marginTop: 30,
  },
}));

export const Parameters = ({ data, setData, setSliderTrigger }) => {
  const classes = useStyles();

  const handleChange = (j, value) => {
    let tempData = [...data];
    tempData[j].value = value;
    setData(tempData);
  };

  return (
    <Box>
      <Box className={classes.box}>
        <Box>
          {data?.map((slider, j) => (
            <Grid container key={j} alignItems="center" spacing={2} className={classes.sliderRow}>
              <Grid item xs={5}>
                <Typography style={{ fontSize: 13 }}>{slider.label}</Typography>
              </Grid>
              <Grid item xs={7}>
                <Slider
                  color={COLORS.viking}
                  value={slider.value}
                  defaultValue={slider.defaultValue}
                  unit={slider.unit}
                  onChange={(_, value) => handleChange(j, value)}
                />
              </Grid>
            </Grid>
          ))}
        </Box>
        <Button
          text="APPLY"
          next
          onClick={() => setSliderTrigger(true)}
          rootStyle={classes.rootStyle}
        />
      </Box>
    </Box>
  );
};
